import type { GraphQLError } from 'graphql';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceBaseQueryBaseQuery, {
	type useSpaceBaseQueryBaseQuery$data,
	type useSpaceBaseQueryBaseQuery$variables,
} from './__generated__/useSpaceBaseQueryBaseQuery.graphql.ts';

export function preloadSpace(spaceKey: useSpaceBaseQueryBaseQuery$variables['spaceKey']): Promise<{
	data: useSpaceBaseQueryBaseQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<useSpaceBaseQueryBaseQuery$data, useSpaceBaseQueryBaseQuery$variables>({
		query: useSpaceBaseQueryBaseQuery,
		variables: {
			spaceKey,
		},
	});
}
